import React from 'react';
import { PendingDispenseNonQLD } from '../components/PendingDispenseNonQLD';

export default function () {
    return <PendingDispenseNonQLD />;
}
